/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

// Import Routes

import { Route as rootRoute } from './routes/__root';
import { Route as ParentImport } from './routes/parent';
import { Route as IndexImport } from './routes/index';
import { Route as CallsIndexImport } from './routes/calls/index';
import { Route as AnalyticsIndexImport } from './routes/analytics/index';
import { Route as XParentImport } from './routes/x_/parent';
import { Route as TestErrorImport } from './routes/test_.error';
import { Route as TestIdImport } from './routes/test.$id';
import { Route as ScheduleRequestHistoryImport } from './routes/schedule/request-history';
import { Route as ScheduleQuickfillHistoryImport } from './routes/schedule/quickfill-history';
import { Route as ScheduleCalendarImport } from './routes/schedule/calendar';
import { Route as ReviewsSiteImport } from './routes/reviews/$site';
import { Route as PaymentsRefundsImport } from './routes/payments/refunds';
import { Route as PaymentsPayoutsImport } from './routes/payments/payouts';
import { Route as PaymentsPaymentPlansImport } from './routes/payments/payment-plans';
import { Route as PaymentsInvoicesImport } from './routes/payments/invoices';
import { Route as NrAuthTestIdImport } from './routes/nr-auth-test.$id';
import { Route as MessagesFilterImport } from './routes/messages/$filter';
import { Route as HomeDashboardImport } from './routes/home/dashboard';
import { Route as FaxFilterImport } from './routes/fax/$filter';
import { Route as ContactsListsImport } from './routes/contacts/lists';
import { Route as ContactsFilterImport } from './routes/contacts/$filter';
import { Route as CallsVoicemailsImport } from './routes/calls/voicemails';
import { Route as CallsCallQueueStatsImport } from './routes/calls/call-queue-stats';
import { Route as CallsCallHistoryImport } from './routes/calls/call-history';
import { Route as BulkSubNavImport } from './routes/bulk_/$subNav';
import { Route as AnalyticsRoiImport } from './routes/analytics/roi';
import { Route as AnalyticsReviewsImport } from './routes/analytics/reviews';
import { Route as AnalyticsPracticeImport } from './routes/analytics/practice';
import { Route as AnalyticsPhoneImport } from './routes/analytics/phone';
import { Route as AnalyticsMessagingImport } from './routes/analytics/messaging';
import { Route as AnalyticsDashboardImport } from './routes/analytics/dashboard';
import { Route as AnalyticsCallIntelligenceImport } from './routes/analytics/call-intelligence';
import { Route as AnalyticsAutoRecallImport } from './routes/analytics/auto-recall';
import { Route as AnalyticsAppointmentImport } from './routes/analytics/appointment';
import { Route as PublicSignInImport } from './routes/_public/sign-in';
import { Route as PublicPasswordResetImport } from './routes/_public/password-reset';
import { Route as PublicLoginImport } from './routes/_public/login';
import { Route as PublicInsuranceEligibilityReportImport } from './routes/_public/insurance-eligibility-report';
import { Route as XRedirect2Import } from './routes/x_/redirect_.2';
import { Route as XRedirect1Import } from './routes/x_/redirect_.1';
import { Route as XParentChildImport } from './routes/x_/parent.child';
import { Route as ReviewsSiteReviewIdImport } from './routes/reviews/$site.$reviewId';
import { Route as PaymentsRefundsInvoiceIdImport } from './routes/payments/refunds_.$invoiceId';
import { Route as PaymentsPayoutsPayoutIdImport } from './routes/payments/payouts_.$payoutId';
import { Route as PaymentsPaymentPlansCreateImport } from './routes/payments/payment-plans_.create';
import { Route as PaymentsPaymentPlansPlanIdImport } from './routes/payments/payment-plans_.$planId';
import { Route as PaymentsInvoicesIdImport } from './routes/payments/invoices_.$id';
import { Route as MessagesFilterNewImport } from './routes/messages/$filter.new';
import { Route as FaxDraftsTemplateEditorImport } from './routes/fax/drafts/template-editor';
import { Route as FaxDraftsNewFromTemplateImport } from './routes/fax/drafts/new-from-template';
import { Route as FaxDraftsNewImport } from './routes/fax/drafts/new';
import { Route as FaxDraftsDraftIdImport } from './routes/fax/drafts/$draftId';
import { Route as FaxFilterFaxIdImport } from './routes/fax/$filter.$faxId';
import { Route as BulkSubNavTypeImport } from './routes/bulk_/$subNav_.$type';
import { Route as AnalyticsRoiNoShowRateImport } from './routes/analytics/roi.no-show-rate';
import { Route as AnalyticsRoiMissedCallTextConversionImport } from './routes/analytics/roi.missed-call-text-conversion';
import { Route as AnalyticsRoiBulkTextImport } from './routes/analytics/roi.bulk-text';
import { Route as AnalyticsRoiAppointmentRemindersImport } from './routes/analytics/roi.appointment-reminders';
import { Route as AnalyticsPracticeMainImport } from './routes/analytics/practice.main';
import { Route as AnalyticsPracticeFeatureImport } from './routes/analytics/practice.$feature';
import { Route as AnalyticsCallIntelligenceMainImport } from './routes/analytics/call-intelligence.main';
import { Route as AnalyticsCallIntelligenceIdImport } from './routes/analytics/call-intelligence.$id';
import { Route as PublicSignInCallbackImport } from './routes/_public/sign-in_.callback';
import { Route as PublicResetPasswordNonceTokenImport } from './routes/_public/reset-password_/$nonceToken';
import { Route as PublicNrPublicTestIdImport } from './routes/_public/nr-public-test.$id';
import { Route as MessagesFilterGroupIdThreadIdImport } from './routes/messages/$filter.$groupId_.$threadId';
import { Route as FaxDraftsDraftIdUploadImport } from './routes/fax/drafts/$draftId.upload';
import { Route as FaxDraftsDraftIdFinalizeImport } from './routes/fax/drafts/$draftId.finalize';
import { Route as FaxDraftsDraftIdCoverImport } from './routes/fax/drafts/$draftId.cover';
import { Route as FaxDraftsDraftIdChooseTemplateImport } from './routes/fax/drafts/$draftId.choose-template';
import { Route as FaxDraftsDraftIdBeginImport } from './routes/fax/drafts/$draftId.begin';
import { Route as BulkSubNavTypeIdImport } from './routes/bulk_/$subNav_.$type_.$id';
import { Route as AnalyticsCallIntelligenceFollowUpsTypeImport } from './routes/analytics/call-intelligence.follow-ups_.$type';
import { Route as PublicTestRedirect2Import } from './routes/_public/test_/redirect_.2';
import { Route as PublicTestRedirect1Import } from './routes/_public/test_/redirect_.1';
import { Route as CallsVoicemailBoxesMailboxIdMessagesMessageIdImport } from './routes/calls/voicemail-boxes.$mailboxId.messages.$messageId';
import { Route as BulkSubNavTypeIdViewImport } from './routes/bulk_/$subNav_.$type_.$id_.$view';
import { Route as PublicUserInviteNonceTokenLocationLocationIdImport } from './routes/_public/user-invite_/$nonceToken_.location_.$locationId';
import { Route as PublicAcceptInviteNonceTokenLocationLocationIdImport } from './routes/_public/accept-invite_/$nonceToken_.location_.$locationId';

// Create/Update Routes

const ParentRoute = ParentImport.update({
  id: '/parent',
  path: '/parent',
  getParentRoute: () => rootRoute,
} as any);

const IndexRoute = IndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRoute,
} as any);

const CallsIndexRoute = CallsIndexImport.update({
  id: '/calls/',
  path: '/calls/',
  getParentRoute: () => rootRoute,
} as any);

const AnalyticsIndexRoute = AnalyticsIndexImport.update({
  id: '/analytics/',
  path: '/analytics/',
  getParentRoute: () => rootRoute,
} as any);

const XParentRoute = XParentImport.update({
  id: '/x_/parent',
  path: '/x/parent',
  getParentRoute: () => rootRoute,
} as any);

const TestErrorRoute = TestErrorImport.update({
  id: '/test_/error',
  path: '/test/error',
  getParentRoute: () => rootRoute,
} as any);

const TestIdRoute = TestIdImport.update({
  id: '/test/$id',
  path: '/test/$id',
  getParentRoute: () => rootRoute,
} as any);

const ScheduleRequestHistoryRoute = ScheduleRequestHistoryImport.update({
  id: '/schedule/request-history',
  path: '/schedule/request-history',
  getParentRoute: () => rootRoute,
} as any);

const ScheduleQuickfillHistoryRoute = ScheduleQuickfillHistoryImport.update({
  id: '/schedule/quickfill-history',
  path: '/schedule/quickfill-history',
  getParentRoute: () => rootRoute,
} as any);

const ScheduleCalendarRoute = ScheduleCalendarImport.update({
  id: '/schedule/calendar',
  path: '/schedule/calendar',
  getParentRoute: () => rootRoute,
} as any);

const ReviewsSiteRoute = ReviewsSiteImport.update({
  id: '/reviews/$site',
  path: '/reviews/$site',
  getParentRoute: () => rootRoute,
} as any);

const PaymentsRefundsRoute = PaymentsRefundsImport.update({
  id: '/payments/refunds',
  path: '/payments/refunds',
  getParentRoute: () => rootRoute,
} as any);

const PaymentsPayoutsRoute = PaymentsPayoutsImport.update({
  id: '/payments/payouts',
  path: '/payments/payouts',
  getParentRoute: () => rootRoute,
} as any);

const PaymentsPaymentPlansRoute = PaymentsPaymentPlansImport.update({
  id: '/payments/payment-plans',
  path: '/payments/payment-plans',
  getParentRoute: () => rootRoute,
} as any);

const PaymentsInvoicesRoute = PaymentsInvoicesImport.update({
  id: '/payments/invoices',
  path: '/payments/invoices',
  getParentRoute: () => rootRoute,
} as any);

const NrAuthTestIdRoute = NrAuthTestIdImport.update({
  id: '/nr-auth-test/$id',
  path: '/nr-auth-test/$id',
  getParentRoute: () => rootRoute,
} as any);

const MessagesFilterRoute = MessagesFilterImport.update({
  id: '/messages/$filter',
  path: '/messages/$filter',
  getParentRoute: () => rootRoute,
} as any);

const HomeDashboardRoute = HomeDashboardImport.update({
  id: '/home/dashboard',
  path: '/home/dashboard',
  getParentRoute: () => rootRoute,
} as any);

const FaxFilterRoute = FaxFilterImport.update({
  id: '/fax/$filter',
  path: '/fax/$filter',
  getParentRoute: () => rootRoute,
} as any);

const ContactsListsRoute = ContactsListsImport.update({
  id: '/contacts/lists',
  path: '/contacts/lists',
  getParentRoute: () => rootRoute,
} as any);

const ContactsFilterRoute = ContactsFilterImport.update({
  id: '/contacts/$filter',
  path: '/contacts/$filter',
  getParentRoute: () => rootRoute,
} as any);

const CallsVoicemailsRoute = CallsVoicemailsImport.update({
  id: '/calls/voicemails',
  path: '/calls/voicemails',
  getParentRoute: () => rootRoute,
} as any);

const CallsCallQueueStatsRoute = CallsCallQueueStatsImport.update({
  id: '/calls/call-queue-stats',
  path: '/calls/call-queue-stats',
  getParentRoute: () => rootRoute,
} as any);

const CallsCallHistoryRoute = CallsCallHistoryImport.update({
  id: '/calls/call-history',
  path: '/calls/call-history',
  getParentRoute: () => rootRoute,
} as any);

const BulkSubNavRoute = BulkSubNavImport.update({
  id: '/bulk_/$subNav',
  path: '/bulk/$subNav',
  getParentRoute: () => rootRoute,
} as any);

const AnalyticsRoiRoute = AnalyticsRoiImport.update({
  id: '/analytics/roi',
  path: '/analytics/roi',
  getParentRoute: () => rootRoute,
} as any);

const AnalyticsReviewsRoute = AnalyticsReviewsImport.update({
  id: '/analytics/reviews',
  path: '/analytics/reviews',
  getParentRoute: () => rootRoute,
} as any);

const AnalyticsPracticeRoute = AnalyticsPracticeImport.update({
  id: '/analytics/practice',
  path: '/analytics/practice',
  getParentRoute: () => rootRoute,
} as any);

const AnalyticsPhoneRoute = AnalyticsPhoneImport.update({
  id: '/analytics/phone',
  path: '/analytics/phone',
  getParentRoute: () => rootRoute,
} as any);

const AnalyticsMessagingRoute = AnalyticsMessagingImport.update({
  id: '/analytics/messaging',
  path: '/analytics/messaging',
  getParentRoute: () => rootRoute,
} as any);

const AnalyticsDashboardRoute = AnalyticsDashboardImport.update({
  id: '/analytics/dashboard',
  path: '/analytics/dashboard',
  getParentRoute: () => rootRoute,
} as any);

const AnalyticsCallIntelligenceRoute = AnalyticsCallIntelligenceImport.update({
  id: '/analytics/call-intelligence',
  path: '/analytics/call-intelligence',
  getParentRoute: () => rootRoute,
} as any);

const AnalyticsAutoRecallRoute = AnalyticsAutoRecallImport.update({
  id: '/analytics/auto-recall',
  path: '/analytics/auto-recall',
  getParentRoute: () => rootRoute,
} as any);

const AnalyticsAppointmentRoute = AnalyticsAppointmentImport.update({
  id: '/analytics/appointment',
  path: '/analytics/appointment',
  getParentRoute: () => rootRoute,
} as any);

const PublicSignInRoute = PublicSignInImport.update({
  id: '/_public/sign-in',
  path: '/sign-in',
  getParentRoute: () => rootRoute,
} as any);

const PublicPasswordResetRoute = PublicPasswordResetImport.update({
  id: '/_public/password-reset',
  path: '/password-reset',
  getParentRoute: () => rootRoute,
} as any);

const PublicLoginRoute = PublicLoginImport.update({
  id: '/_public/login',
  path: '/login',
  getParentRoute: () => rootRoute,
} as any);

const PublicInsuranceEligibilityReportRoute = PublicInsuranceEligibilityReportImport.update({
  id: '/_public/insurance-eligibility-report',
  path: '/insurance-eligibility-report',
  getParentRoute: () => rootRoute,
} as any);

const XRedirect2Route = XRedirect2Import.update({
  id: '/x_/redirect_/2',
  path: '/x/redirect/2',
  getParentRoute: () => rootRoute,
} as any);

const XRedirect1Route = XRedirect1Import.update({
  id: '/x_/redirect_/1',
  path: '/x/redirect/1',
  getParentRoute: () => rootRoute,
} as any);

const XParentChildRoute = XParentChildImport.update({
  id: '/child',
  path: '/child',
  getParentRoute: () => XParentRoute,
} as any);

const ReviewsSiteReviewIdRoute = ReviewsSiteReviewIdImport.update({
  id: '/$reviewId',
  path: '/$reviewId',
  getParentRoute: () => ReviewsSiteRoute,
} as any);

const PaymentsRefundsInvoiceIdRoute = PaymentsRefundsInvoiceIdImport.update({
  id: '/payments/refunds_/$invoiceId',
  path: '/payments/refunds/$invoiceId',
  getParentRoute: () => rootRoute,
} as any);

const PaymentsPayoutsPayoutIdRoute = PaymentsPayoutsPayoutIdImport.update({
  id: '/payments/payouts_/$payoutId',
  path: '/payments/payouts/$payoutId',
  getParentRoute: () => rootRoute,
} as any);

const PaymentsPaymentPlansCreateRoute = PaymentsPaymentPlansCreateImport.update({
  id: '/payments/payment-plans_/create',
  path: '/payments/payment-plans/create',
  getParentRoute: () => rootRoute,
} as any);

const PaymentsPaymentPlansPlanIdRoute = PaymentsPaymentPlansPlanIdImport.update({
  id: '/payments/payment-plans_/$planId',
  path: '/payments/payment-plans/$planId',
  getParentRoute: () => rootRoute,
} as any);

const PaymentsInvoicesIdRoute = PaymentsInvoicesIdImport.update({
  id: '/payments/invoices_/$id',
  path: '/payments/invoices/$id',
  getParentRoute: () => rootRoute,
} as any);

const MessagesFilterNewRoute = MessagesFilterNewImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => MessagesFilterRoute,
} as any);

const FaxDraftsTemplateEditorRoute = FaxDraftsTemplateEditorImport.update({
  id: '/fax/drafts/template-editor',
  path: '/fax/drafts/template-editor',
  getParentRoute: () => rootRoute,
} as any);

const FaxDraftsNewFromTemplateRoute = FaxDraftsNewFromTemplateImport.update({
  id: '/fax/drafts/new-from-template',
  path: '/fax/drafts/new-from-template',
  getParentRoute: () => rootRoute,
} as any);

const FaxDraftsNewRoute = FaxDraftsNewImport.update({
  id: '/fax/drafts/new',
  path: '/fax/drafts/new',
  getParentRoute: () => rootRoute,
} as any);

const FaxDraftsDraftIdRoute = FaxDraftsDraftIdImport.update({
  id: '/fax/drafts/$draftId',
  path: '/fax/drafts/$draftId',
  getParentRoute: () => rootRoute,
} as any);

const FaxFilterFaxIdRoute = FaxFilterFaxIdImport.update({
  id: '/$faxId',
  path: '/$faxId',
  getParentRoute: () => FaxFilterRoute,
} as any);

const BulkSubNavTypeRoute = BulkSubNavTypeImport.update({
  id: '/bulk_/$subNav_/$type',
  path: '/bulk/$subNav/$type',
  getParentRoute: () => rootRoute,
} as any);

const AnalyticsRoiNoShowRateRoute = AnalyticsRoiNoShowRateImport.update({
  id: '/no-show-rate',
  path: '/no-show-rate',
  getParentRoute: () => AnalyticsRoiRoute,
} as any);

const AnalyticsRoiMissedCallTextConversionRoute = AnalyticsRoiMissedCallTextConversionImport.update({
  id: '/missed-call-text-conversion',
  path: '/missed-call-text-conversion',
  getParentRoute: () => AnalyticsRoiRoute,
} as any);

const AnalyticsRoiBulkTextRoute = AnalyticsRoiBulkTextImport.update({
  id: '/bulk-text',
  path: '/bulk-text',
  getParentRoute: () => AnalyticsRoiRoute,
} as any);

const AnalyticsRoiAppointmentRemindersRoute = AnalyticsRoiAppointmentRemindersImport.update({
  id: '/appointment-reminders',
  path: '/appointment-reminders',
  getParentRoute: () => AnalyticsRoiRoute,
} as any);

const AnalyticsPracticeMainRoute = AnalyticsPracticeMainImport.update({
  id: '/main',
  path: '/main',
  getParentRoute: () => AnalyticsPracticeRoute,
} as any);

const AnalyticsPracticeFeatureRoute = AnalyticsPracticeFeatureImport.update({
  id: '/$feature',
  path: '/$feature',
  getParentRoute: () => AnalyticsPracticeRoute,
} as any);

const AnalyticsCallIntelligenceMainRoute = AnalyticsCallIntelligenceMainImport.update({
  id: '/main',
  path: '/main',
  getParentRoute: () => AnalyticsCallIntelligenceRoute,
} as any);

const AnalyticsCallIntelligenceIdRoute = AnalyticsCallIntelligenceIdImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => AnalyticsCallIntelligenceRoute,
} as any);

const PublicSignInCallbackRoute = PublicSignInCallbackImport.update({
  id: '/_public/sign-in_/callback',
  path: '/sign-in/callback',
  getParentRoute: () => rootRoute,
} as any);

const PublicResetPasswordNonceTokenRoute = PublicResetPasswordNonceTokenImport.update({
  id: '/_public/reset-password_/$nonceToken',
  path: '/reset-password/$nonceToken',
  getParentRoute: () => rootRoute,
} as any);

const PublicNrPublicTestIdRoute = PublicNrPublicTestIdImport.update({
  id: '/_public/nr-public-test/$id',
  path: '/nr-public-test/$id',
  getParentRoute: () => rootRoute,
} as any);

const MessagesFilterGroupIdThreadIdRoute = MessagesFilterGroupIdThreadIdImport.update({
  id: '/$groupId_/$threadId',
  path: '/$groupId/$threadId',
  getParentRoute: () => MessagesFilterRoute,
} as any);

const FaxDraftsDraftIdUploadRoute = FaxDraftsDraftIdUploadImport.update({
  id: '/upload',
  path: '/upload',
  getParentRoute: () => FaxDraftsDraftIdRoute,
} as any);

const FaxDraftsDraftIdFinalizeRoute = FaxDraftsDraftIdFinalizeImport.update({
  id: '/finalize',
  path: '/finalize',
  getParentRoute: () => FaxDraftsDraftIdRoute,
} as any);

const FaxDraftsDraftIdCoverRoute = FaxDraftsDraftIdCoverImport.update({
  id: '/cover',
  path: '/cover',
  getParentRoute: () => FaxDraftsDraftIdRoute,
} as any);

const FaxDraftsDraftIdChooseTemplateRoute = FaxDraftsDraftIdChooseTemplateImport.update({
  id: '/choose-template',
  path: '/choose-template',
  getParentRoute: () => FaxDraftsDraftIdRoute,
} as any);

const FaxDraftsDraftIdBeginRoute = FaxDraftsDraftIdBeginImport.update({
  id: '/begin',
  path: '/begin',
  getParentRoute: () => FaxDraftsDraftIdRoute,
} as any);

const BulkSubNavTypeIdRoute = BulkSubNavTypeIdImport.update({
  id: '/bulk_/$subNav_/$type_/$id',
  path: '/bulk/$subNav/$type/$id',
  getParentRoute: () => rootRoute,
} as any);

const AnalyticsCallIntelligenceFollowUpsTypeRoute = AnalyticsCallIntelligenceFollowUpsTypeImport.update({
  id: '/follow-ups_/$type',
  path: '/follow-ups/$type',
  getParentRoute: () => AnalyticsCallIntelligenceRoute,
} as any);

const PublicTestRedirect2Route = PublicTestRedirect2Import.update({
  id: '/_public/test_/redirect_/2',
  path: '/test/redirect/2',
  getParentRoute: () => rootRoute,
} as any);

const PublicTestRedirect1Route = PublicTestRedirect1Import.update({
  id: '/_public/test_/redirect_/1',
  path: '/test/redirect/1',
  getParentRoute: () => rootRoute,
} as any);

const CallsVoicemailBoxesMailboxIdMessagesMessageIdRoute = CallsVoicemailBoxesMailboxIdMessagesMessageIdImport.update({
  id: '/calls/voicemail-boxes/$mailboxId/messages/$messageId',
  path: '/calls/voicemail-boxes/$mailboxId/messages/$messageId',
  getParentRoute: () => rootRoute,
} as any);

const BulkSubNavTypeIdViewRoute = BulkSubNavTypeIdViewImport.update({
  id: '/bulk_/$subNav_/$type_/$id_/$view',
  path: '/bulk/$subNav/$type/$id/$view',
  getParentRoute: () => rootRoute,
} as any);

const PublicUserInviteNonceTokenLocationLocationIdRoute = PublicUserInviteNonceTokenLocationLocationIdImport.update({
  id: '/_public/user-invite_/$nonceToken_/location_/$locationId',
  path: '/user-invite/$nonceToken/location/$locationId',
  getParentRoute: () => rootRoute,
} as any);

const PublicAcceptInviteNonceTokenLocationLocationIdRoute = PublicAcceptInviteNonceTokenLocationLocationIdImport.update(
  {
    id: '/_public/accept-invite_/$nonceToken_/location_/$locationId',
    path: '/accept-invite/$nonceToken/location/$locationId',
    getParentRoute: () => rootRoute,
  } as any
);

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/';
      path: '/';
      fullPath: '/';
      preLoaderRoute: typeof IndexImport;
      parentRoute: typeof rootRoute;
    };
    '/parent': {
      id: '/parent';
      path: '/parent';
      fullPath: '/parent';
      preLoaderRoute: typeof ParentImport;
      parentRoute: typeof rootRoute;
    };
    '/_public/insurance-eligibility-report': {
      id: '/_public/insurance-eligibility-report';
      path: '/insurance-eligibility-report';
      fullPath: '/insurance-eligibility-report';
      preLoaderRoute: typeof PublicInsuranceEligibilityReportImport;
      parentRoute: typeof rootRoute;
    };
    '/_public/login': {
      id: '/_public/login';
      path: '/login';
      fullPath: '/login';
      preLoaderRoute: typeof PublicLoginImport;
      parentRoute: typeof rootRoute;
    };
    '/_public/password-reset': {
      id: '/_public/password-reset';
      path: '/password-reset';
      fullPath: '/password-reset';
      preLoaderRoute: typeof PublicPasswordResetImport;
      parentRoute: typeof rootRoute;
    };
    '/_public/sign-in': {
      id: '/_public/sign-in';
      path: '/sign-in';
      fullPath: '/sign-in';
      preLoaderRoute: typeof PublicSignInImport;
      parentRoute: typeof rootRoute;
    };
    '/analytics/appointment': {
      id: '/analytics/appointment';
      path: '/analytics/appointment';
      fullPath: '/analytics/appointment';
      preLoaderRoute: typeof AnalyticsAppointmentImport;
      parentRoute: typeof rootRoute;
    };
    '/analytics/auto-recall': {
      id: '/analytics/auto-recall';
      path: '/analytics/auto-recall';
      fullPath: '/analytics/auto-recall';
      preLoaderRoute: typeof AnalyticsAutoRecallImport;
      parentRoute: typeof rootRoute;
    };
    '/analytics/call-intelligence': {
      id: '/analytics/call-intelligence';
      path: '/analytics/call-intelligence';
      fullPath: '/analytics/call-intelligence';
      preLoaderRoute: typeof AnalyticsCallIntelligenceImport;
      parentRoute: typeof rootRoute;
    };
    '/analytics/dashboard': {
      id: '/analytics/dashboard';
      path: '/analytics/dashboard';
      fullPath: '/analytics/dashboard';
      preLoaderRoute: typeof AnalyticsDashboardImport;
      parentRoute: typeof rootRoute;
    };
    '/analytics/messaging': {
      id: '/analytics/messaging';
      path: '/analytics/messaging';
      fullPath: '/analytics/messaging';
      preLoaderRoute: typeof AnalyticsMessagingImport;
      parentRoute: typeof rootRoute;
    };
    '/analytics/phone': {
      id: '/analytics/phone';
      path: '/analytics/phone';
      fullPath: '/analytics/phone';
      preLoaderRoute: typeof AnalyticsPhoneImport;
      parentRoute: typeof rootRoute;
    };
    '/analytics/practice': {
      id: '/analytics/practice';
      path: '/analytics/practice';
      fullPath: '/analytics/practice';
      preLoaderRoute: typeof AnalyticsPracticeImport;
      parentRoute: typeof rootRoute;
    };
    '/analytics/reviews': {
      id: '/analytics/reviews';
      path: '/analytics/reviews';
      fullPath: '/analytics/reviews';
      preLoaderRoute: typeof AnalyticsReviewsImport;
      parentRoute: typeof rootRoute;
    };
    '/analytics/roi': {
      id: '/analytics/roi';
      path: '/analytics/roi';
      fullPath: '/analytics/roi';
      preLoaderRoute: typeof AnalyticsRoiImport;
      parentRoute: typeof rootRoute;
    };
    '/bulk_/$subNav': {
      id: '/bulk_/$subNav';
      path: '/bulk/$subNav';
      fullPath: '/bulk/$subNav';
      preLoaderRoute: typeof BulkSubNavImport;
      parentRoute: typeof rootRoute;
    };
    '/calls/call-history': {
      id: '/calls/call-history';
      path: '/calls/call-history';
      fullPath: '/calls/call-history';
      preLoaderRoute: typeof CallsCallHistoryImport;
      parentRoute: typeof rootRoute;
    };
    '/calls/call-queue-stats': {
      id: '/calls/call-queue-stats';
      path: '/calls/call-queue-stats';
      fullPath: '/calls/call-queue-stats';
      preLoaderRoute: typeof CallsCallQueueStatsImport;
      parentRoute: typeof rootRoute;
    };
    '/calls/voicemails': {
      id: '/calls/voicemails';
      path: '/calls/voicemails';
      fullPath: '/calls/voicemails';
      preLoaderRoute: typeof CallsVoicemailsImport;
      parentRoute: typeof rootRoute;
    };
    '/contacts/$filter': {
      id: '/contacts/$filter';
      path: '/contacts/$filter';
      fullPath: '/contacts/$filter';
      preLoaderRoute: typeof ContactsFilterImport;
      parentRoute: typeof rootRoute;
    };
    '/contacts/lists': {
      id: '/contacts/lists';
      path: '/contacts/lists';
      fullPath: '/contacts/lists';
      preLoaderRoute: typeof ContactsListsImport;
      parentRoute: typeof rootRoute;
    };
    '/fax/$filter': {
      id: '/fax/$filter';
      path: '/fax/$filter';
      fullPath: '/fax/$filter';
      preLoaderRoute: typeof FaxFilterImport;
      parentRoute: typeof rootRoute;
    };
    '/home/dashboard': {
      id: '/home/dashboard';
      path: '/home/dashboard';
      fullPath: '/home/dashboard';
      preLoaderRoute: typeof HomeDashboardImport;
      parentRoute: typeof rootRoute;
    };
    '/messages/$filter': {
      id: '/messages/$filter';
      path: '/messages/$filter';
      fullPath: '/messages/$filter';
      preLoaderRoute: typeof MessagesFilterImport;
      parentRoute: typeof rootRoute;
    };
    '/nr-auth-test/$id': {
      id: '/nr-auth-test/$id';
      path: '/nr-auth-test/$id';
      fullPath: '/nr-auth-test/$id';
      preLoaderRoute: typeof NrAuthTestIdImport;
      parentRoute: typeof rootRoute;
    };
    '/payments/invoices': {
      id: '/payments/invoices';
      path: '/payments/invoices';
      fullPath: '/payments/invoices';
      preLoaderRoute: typeof PaymentsInvoicesImport;
      parentRoute: typeof rootRoute;
    };
    '/payments/payment-plans': {
      id: '/payments/payment-plans';
      path: '/payments/payment-plans';
      fullPath: '/payments/payment-plans';
      preLoaderRoute: typeof PaymentsPaymentPlansImport;
      parentRoute: typeof rootRoute;
    };
    '/payments/payouts': {
      id: '/payments/payouts';
      path: '/payments/payouts';
      fullPath: '/payments/payouts';
      preLoaderRoute: typeof PaymentsPayoutsImport;
      parentRoute: typeof rootRoute;
    };
    '/payments/refunds': {
      id: '/payments/refunds';
      path: '/payments/refunds';
      fullPath: '/payments/refunds';
      preLoaderRoute: typeof PaymentsRefundsImport;
      parentRoute: typeof rootRoute;
    };
    '/reviews/$site': {
      id: '/reviews/$site';
      path: '/reviews/$site';
      fullPath: '/reviews/$site';
      preLoaderRoute: typeof ReviewsSiteImport;
      parentRoute: typeof rootRoute;
    };
    '/schedule/calendar': {
      id: '/schedule/calendar';
      path: '/schedule/calendar';
      fullPath: '/schedule/calendar';
      preLoaderRoute: typeof ScheduleCalendarImport;
      parentRoute: typeof rootRoute;
    };
    '/schedule/quickfill-history': {
      id: '/schedule/quickfill-history';
      path: '/schedule/quickfill-history';
      fullPath: '/schedule/quickfill-history';
      preLoaderRoute: typeof ScheduleQuickfillHistoryImport;
      parentRoute: typeof rootRoute;
    };
    '/schedule/request-history': {
      id: '/schedule/request-history';
      path: '/schedule/request-history';
      fullPath: '/schedule/request-history';
      preLoaderRoute: typeof ScheduleRequestHistoryImport;
      parentRoute: typeof rootRoute;
    };
    '/test/$id': {
      id: '/test/$id';
      path: '/test/$id';
      fullPath: '/test/$id';
      preLoaderRoute: typeof TestIdImport;
      parentRoute: typeof rootRoute;
    };
    '/test_/error': {
      id: '/test_/error';
      path: '/test/error';
      fullPath: '/test/error';
      preLoaderRoute: typeof TestErrorImport;
      parentRoute: typeof rootRoute;
    };
    '/x_/parent': {
      id: '/x_/parent';
      path: '/x/parent';
      fullPath: '/x/parent';
      preLoaderRoute: typeof XParentImport;
      parentRoute: typeof rootRoute;
    };
    '/analytics/': {
      id: '/analytics/';
      path: '/analytics';
      fullPath: '/analytics';
      preLoaderRoute: typeof AnalyticsIndexImport;
      parentRoute: typeof rootRoute;
    };
    '/calls/': {
      id: '/calls/';
      path: '/calls';
      fullPath: '/calls';
      preLoaderRoute: typeof CallsIndexImport;
      parentRoute: typeof rootRoute;
    };
    '/_public/nr-public-test/$id': {
      id: '/_public/nr-public-test/$id';
      path: '/nr-public-test/$id';
      fullPath: '/nr-public-test/$id';
      preLoaderRoute: typeof PublicNrPublicTestIdImport;
      parentRoute: typeof rootRoute;
    };
    '/_public/reset-password_/$nonceToken': {
      id: '/_public/reset-password_/$nonceToken';
      path: '/reset-password/$nonceToken';
      fullPath: '/reset-password/$nonceToken';
      preLoaderRoute: typeof PublicResetPasswordNonceTokenImport;
      parentRoute: typeof rootRoute;
    };
    '/_public/sign-in_/callback': {
      id: '/_public/sign-in_/callback';
      path: '/sign-in/callback';
      fullPath: '/sign-in/callback';
      preLoaderRoute: typeof PublicSignInCallbackImport;
      parentRoute: typeof rootRoute;
    };
    '/analytics/call-intelligence/$id': {
      id: '/analytics/call-intelligence/$id';
      path: '/$id';
      fullPath: '/analytics/call-intelligence/$id';
      preLoaderRoute: typeof AnalyticsCallIntelligenceIdImport;
      parentRoute: typeof AnalyticsCallIntelligenceImport;
    };
    '/analytics/call-intelligence/main': {
      id: '/analytics/call-intelligence/main';
      path: '/main';
      fullPath: '/analytics/call-intelligence/main';
      preLoaderRoute: typeof AnalyticsCallIntelligenceMainImport;
      parentRoute: typeof AnalyticsCallIntelligenceImport;
    };
    '/analytics/practice/$feature': {
      id: '/analytics/practice/$feature';
      path: '/$feature';
      fullPath: '/analytics/practice/$feature';
      preLoaderRoute: typeof AnalyticsPracticeFeatureImport;
      parentRoute: typeof AnalyticsPracticeImport;
    };
    '/analytics/practice/main': {
      id: '/analytics/practice/main';
      path: '/main';
      fullPath: '/analytics/practice/main';
      preLoaderRoute: typeof AnalyticsPracticeMainImport;
      parentRoute: typeof AnalyticsPracticeImport;
    };
    '/analytics/roi/appointment-reminders': {
      id: '/analytics/roi/appointment-reminders';
      path: '/appointment-reminders';
      fullPath: '/analytics/roi/appointment-reminders';
      preLoaderRoute: typeof AnalyticsRoiAppointmentRemindersImport;
      parentRoute: typeof AnalyticsRoiImport;
    };
    '/analytics/roi/bulk-text': {
      id: '/analytics/roi/bulk-text';
      path: '/bulk-text';
      fullPath: '/analytics/roi/bulk-text';
      preLoaderRoute: typeof AnalyticsRoiBulkTextImport;
      parentRoute: typeof AnalyticsRoiImport;
    };
    '/analytics/roi/missed-call-text-conversion': {
      id: '/analytics/roi/missed-call-text-conversion';
      path: '/missed-call-text-conversion';
      fullPath: '/analytics/roi/missed-call-text-conversion';
      preLoaderRoute: typeof AnalyticsRoiMissedCallTextConversionImport;
      parentRoute: typeof AnalyticsRoiImport;
    };
    '/analytics/roi/no-show-rate': {
      id: '/analytics/roi/no-show-rate';
      path: '/no-show-rate';
      fullPath: '/analytics/roi/no-show-rate';
      preLoaderRoute: typeof AnalyticsRoiNoShowRateImport;
      parentRoute: typeof AnalyticsRoiImport;
    };
    '/bulk_/$subNav_/$type': {
      id: '/bulk_/$subNav_/$type';
      path: '/bulk/$subNav/$type';
      fullPath: '/bulk/$subNav/$type';
      preLoaderRoute: typeof BulkSubNavTypeImport;
      parentRoute: typeof rootRoute;
    };
    '/fax/$filter/$faxId': {
      id: '/fax/$filter/$faxId';
      path: '/$faxId';
      fullPath: '/fax/$filter/$faxId';
      preLoaderRoute: typeof FaxFilterFaxIdImport;
      parentRoute: typeof FaxFilterImport;
    };
    '/fax/drafts/$draftId': {
      id: '/fax/drafts/$draftId';
      path: '/fax/drafts/$draftId';
      fullPath: '/fax/drafts/$draftId';
      preLoaderRoute: typeof FaxDraftsDraftIdImport;
      parentRoute: typeof rootRoute;
    };
    '/fax/drafts/new': {
      id: '/fax/drafts/new';
      path: '/fax/drafts/new';
      fullPath: '/fax/drafts/new';
      preLoaderRoute: typeof FaxDraftsNewImport;
      parentRoute: typeof rootRoute;
    };
    '/fax/drafts/new-from-template': {
      id: '/fax/drafts/new-from-template';
      path: '/fax/drafts/new-from-template';
      fullPath: '/fax/drafts/new-from-template';
      preLoaderRoute: typeof FaxDraftsNewFromTemplateImport;
      parentRoute: typeof rootRoute;
    };
    '/fax/drafts/template-editor': {
      id: '/fax/drafts/template-editor';
      path: '/fax/drafts/template-editor';
      fullPath: '/fax/drafts/template-editor';
      preLoaderRoute: typeof FaxDraftsTemplateEditorImport;
      parentRoute: typeof rootRoute;
    };
    '/messages/$filter/new': {
      id: '/messages/$filter/new';
      path: '/new';
      fullPath: '/messages/$filter/new';
      preLoaderRoute: typeof MessagesFilterNewImport;
      parentRoute: typeof MessagesFilterImport;
    };
    '/payments/invoices_/$id': {
      id: '/payments/invoices_/$id';
      path: '/payments/invoices/$id';
      fullPath: '/payments/invoices/$id';
      preLoaderRoute: typeof PaymentsInvoicesIdImport;
      parentRoute: typeof rootRoute;
    };
    '/payments/payment-plans_/$planId': {
      id: '/payments/payment-plans_/$planId';
      path: '/payments/payment-plans/$planId';
      fullPath: '/payments/payment-plans/$planId';
      preLoaderRoute: typeof PaymentsPaymentPlansPlanIdImport;
      parentRoute: typeof rootRoute;
    };
    '/payments/payment-plans_/create': {
      id: '/payments/payment-plans_/create';
      path: '/payments/payment-plans/create';
      fullPath: '/payments/payment-plans/create';
      preLoaderRoute: typeof PaymentsPaymentPlansCreateImport;
      parentRoute: typeof rootRoute;
    };
    '/payments/payouts_/$payoutId': {
      id: '/payments/payouts_/$payoutId';
      path: '/payments/payouts/$payoutId';
      fullPath: '/payments/payouts/$payoutId';
      preLoaderRoute: typeof PaymentsPayoutsPayoutIdImport;
      parentRoute: typeof rootRoute;
    };
    '/payments/refunds_/$invoiceId': {
      id: '/payments/refunds_/$invoiceId';
      path: '/payments/refunds/$invoiceId';
      fullPath: '/payments/refunds/$invoiceId';
      preLoaderRoute: typeof PaymentsRefundsInvoiceIdImport;
      parentRoute: typeof rootRoute;
    };
    '/reviews/$site/$reviewId': {
      id: '/reviews/$site/$reviewId';
      path: '/$reviewId';
      fullPath: '/reviews/$site/$reviewId';
      preLoaderRoute: typeof ReviewsSiteReviewIdImport;
      parentRoute: typeof ReviewsSiteImport;
    };
    '/x_/parent/child': {
      id: '/x_/parent/child';
      path: '/child';
      fullPath: '/x/parent/child';
      preLoaderRoute: typeof XParentChildImport;
      parentRoute: typeof XParentImport;
    };
    '/x_/redirect_/1': {
      id: '/x_/redirect_/1';
      path: '/x/redirect/1';
      fullPath: '/x/redirect/1';
      preLoaderRoute: typeof XRedirect1Import;
      parentRoute: typeof rootRoute;
    };
    '/x_/redirect_/2': {
      id: '/x_/redirect_/2';
      path: '/x/redirect/2';
      fullPath: '/x/redirect/2';
      preLoaderRoute: typeof XRedirect2Import;
      parentRoute: typeof rootRoute;
    };
    '/_public/test_/redirect_/1': {
      id: '/_public/test_/redirect_/1';
      path: '/test/redirect/1';
      fullPath: '/test/redirect/1';
      preLoaderRoute: typeof PublicTestRedirect1Import;
      parentRoute: typeof rootRoute;
    };
    '/_public/test_/redirect_/2': {
      id: '/_public/test_/redirect_/2';
      path: '/test/redirect/2';
      fullPath: '/test/redirect/2';
      preLoaderRoute: typeof PublicTestRedirect2Import;
      parentRoute: typeof rootRoute;
    };
    '/analytics/call-intelligence/follow-ups_/$type': {
      id: '/analytics/call-intelligence/follow-ups_/$type';
      path: '/follow-ups/$type';
      fullPath: '/analytics/call-intelligence/follow-ups/$type';
      preLoaderRoute: typeof AnalyticsCallIntelligenceFollowUpsTypeImport;
      parentRoute: typeof AnalyticsCallIntelligenceImport;
    };
    '/bulk_/$subNav_/$type_/$id': {
      id: '/bulk_/$subNav_/$type_/$id';
      path: '/bulk/$subNav/$type/$id';
      fullPath: '/bulk/$subNav/$type/$id';
      preLoaderRoute: typeof BulkSubNavTypeIdImport;
      parentRoute: typeof rootRoute;
    };
    '/fax/drafts/$draftId/begin': {
      id: '/fax/drafts/$draftId/begin';
      path: '/begin';
      fullPath: '/fax/drafts/$draftId/begin';
      preLoaderRoute: typeof FaxDraftsDraftIdBeginImport;
      parentRoute: typeof FaxDraftsDraftIdImport;
    };
    '/fax/drafts/$draftId/choose-template': {
      id: '/fax/drafts/$draftId/choose-template';
      path: '/choose-template';
      fullPath: '/fax/drafts/$draftId/choose-template';
      preLoaderRoute: typeof FaxDraftsDraftIdChooseTemplateImport;
      parentRoute: typeof FaxDraftsDraftIdImport;
    };
    '/fax/drafts/$draftId/cover': {
      id: '/fax/drafts/$draftId/cover';
      path: '/cover';
      fullPath: '/fax/drafts/$draftId/cover';
      preLoaderRoute: typeof FaxDraftsDraftIdCoverImport;
      parentRoute: typeof FaxDraftsDraftIdImport;
    };
    '/fax/drafts/$draftId/finalize': {
      id: '/fax/drafts/$draftId/finalize';
      path: '/finalize';
      fullPath: '/fax/drafts/$draftId/finalize';
      preLoaderRoute: typeof FaxDraftsDraftIdFinalizeImport;
      parentRoute: typeof FaxDraftsDraftIdImport;
    };
    '/fax/drafts/$draftId/upload': {
      id: '/fax/drafts/$draftId/upload';
      path: '/upload';
      fullPath: '/fax/drafts/$draftId/upload';
      preLoaderRoute: typeof FaxDraftsDraftIdUploadImport;
      parentRoute: typeof FaxDraftsDraftIdImport;
    };
    '/messages/$filter/$groupId_/$threadId': {
      id: '/messages/$filter/$groupId_/$threadId';
      path: '/$groupId/$threadId';
      fullPath: '/messages/$filter/$groupId/$threadId';
      preLoaderRoute: typeof MessagesFilterGroupIdThreadIdImport;
      parentRoute: typeof MessagesFilterImport;
    };
    '/_public/accept-invite_/$nonceToken_/location_/$locationId': {
      id: '/_public/accept-invite_/$nonceToken_/location_/$locationId';
      path: '/accept-invite/$nonceToken/location/$locationId';
      fullPath: '/accept-invite/$nonceToken/location/$locationId';
      preLoaderRoute: typeof PublicAcceptInviteNonceTokenLocationLocationIdImport;
      parentRoute: typeof rootRoute;
    };
    '/_public/user-invite_/$nonceToken_/location_/$locationId': {
      id: '/_public/user-invite_/$nonceToken_/location_/$locationId';
      path: '/user-invite/$nonceToken/location/$locationId';
      fullPath: '/user-invite/$nonceToken/location/$locationId';
      preLoaderRoute: typeof PublicUserInviteNonceTokenLocationLocationIdImport;
      parentRoute: typeof rootRoute;
    };
    '/bulk_/$subNav_/$type_/$id_/$view': {
      id: '/bulk_/$subNav_/$type_/$id_/$view';
      path: '/bulk/$subNav/$type/$id/$view';
      fullPath: '/bulk/$subNav/$type/$id/$view';
      preLoaderRoute: typeof BulkSubNavTypeIdViewImport;
      parentRoute: typeof rootRoute;
    };
    '/calls/voicemail-boxes/$mailboxId/messages/$messageId': {
      id: '/calls/voicemail-boxes/$mailboxId/messages/$messageId';
      path: '/calls/voicemail-boxes/$mailboxId/messages/$messageId';
      fullPath: '/calls/voicemail-boxes/$mailboxId/messages/$messageId';
      preLoaderRoute: typeof CallsVoicemailBoxesMailboxIdMessagesMessageIdImport;
      parentRoute: typeof rootRoute;
    };
  }
}

// Create and export the route tree

interface AnalyticsCallIntelligenceRouteChildren {
  AnalyticsCallIntelligenceIdRoute: typeof AnalyticsCallIntelligenceIdRoute;
  AnalyticsCallIntelligenceMainRoute: typeof AnalyticsCallIntelligenceMainRoute;
  AnalyticsCallIntelligenceFollowUpsTypeRoute: typeof AnalyticsCallIntelligenceFollowUpsTypeRoute;
}

const AnalyticsCallIntelligenceRouteChildren: AnalyticsCallIntelligenceRouteChildren = {
  AnalyticsCallIntelligenceIdRoute: AnalyticsCallIntelligenceIdRoute,
  AnalyticsCallIntelligenceMainRoute: AnalyticsCallIntelligenceMainRoute,
  AnalyticsCallIntelligenceFollowUpsTypeRoute: AnalyticsCallIntelligenceFollowUpsTypeRoute,
};

const AnalyticsCallIntelligenceRouteWithChildren = AnalyticsCallIntelligenceRoute._addFileChildren(
  AnalyticsCallIntelligenceRouteChildren
);

interface AnalyticsPracticeRouteChildren {
  AnalyticsPracticeFeatureRoute: typeof AnalyticsPracticeFeatureRoute;
  AnalyticsPracticeMainRoute: typeof AnalyticsPracticeMainRoute;
}

const AnalyticsPracticeRouteChildren: AnalyticsPracticeRouteChildren = {
  AnalyticsPracticeFeatureRoute: AnalyticsPracticeFeatureRoute,
  AnalyticsPracticeMainRoute: AnalyticsPracticeMainRoute,
};

const AnalyticsPracticeRouteWithChildren = AnalyticsPracticeRoute._addFileChildren(AnalyticsPracticeRouteChildren);

interface AnalyticsRoiRouteChildren {
  AnalyticsRoiAppointmentRemindersRoute: typeof AnalyticsRoiAppointmentRemindersRoute;
  AnalyticsRoiBulkTextRoute: typeof AnalyticsRoiBulkTextRoute;
  AnalyticsRoiMissedCallTextConversionRoute: typeof AnalyticsRoiMissedCallTextConversionRoute;
  AnalyticsRoiNoShowRateRoute: typeof AnalyticsRoiNoShowRateRoute;
}

const AnalyticsRoiRouteChildren: AnalyticsRoiRouteChildren = {
  AnalyticsRoiAppointmentRemindersRoute: AnalyticsRoiAppointmentRemindersRoute,
  AnalyticsRoiBulkTextRoute: AnalyticsRoiBulkTextRoute,
  AnalyticsRoiMissedCallTextConversionRoute: AnalyticsRoiMissedCallTextConversionRoute,
  AnalyticsRoiNoShowRateRoute: AnalyticsRoiNoShowRateRoute,
};

const AnalyticsRoiRouteWithChildren = AnalyticsRoiRoute._addFileChildren(AnalyticsRoiRouteChildren);

interface FaxFilterRouteChildren {
  FaxFilterFaxIdRoute: typeof FaxFilterFaxIdRoute;
}

const FaxFilterRouteChildren: FaxFilterRouteChildren = {
  FaxFilterFaxIdRoute: FaxFilterFaxIdRoute,
};

const FaxFilterRouteWithChildren = FaxFilterRoute._addFileChildren(FaxFilterRouteChildren);

interface MessagesFilterRouteChildren {
  MessagesFilterNewRoute: typeof MessagesFilterNewRoute;
  MessagesFilterGroupIdThreadIdRoute: typeof MessagesFilterGroupIdThreadIdRoute;
}

const MessagesFilterRouteChildren: MessagesFilterRouteChildren = {
  MessagesFilterNewRoute: MessagesFilterNewRoute,
  MessagesFilterGroupIdThreadIdRoute: MessagesFilterGroupIdThreadIdRoute,
};

const MessagesFilterRouteWithChildren = MessagesFilterRoute._addFileChildren(MessagesFilterRouteChildren);

interface ReviewsSiteRouteChildren {
  ReviewsSiteReviewIdRoute: typeof ReviewsSiteReviewIdRoute;
}

const ReviewsSiteRouteChildren: ReviewsSiteRouteChildren = {
  ReviewsSiteReviewIdRoute: ReviewsSiteReviewIdRoute,
};

const ReviewsSiteRouteWithChildren = ReviewsSiteRoute._addFileChildren(ReviewsSiteRouteChildren);

interface XParentRouteChildren {
  XParentChildRoute: typeof XParentChildRoute;
}

const XParentRouteChildren: XParentRouteChildren = {
  XParentChildRoute: XParentChildRoute,
};

const XParentRouteWithChildren = XParentRoute._addFileChildren(XParentRouteChildren);

interface FaxDraftsDraftIdRouteChildren {
  FaxDraftsDraftIdBeginRoute: typeof FaxDraftsDraftIdBeginRoute;
  FaxDraftsDraftIdChooseTemplateRoute: typeof FaxDraftsDraftIdChooseTemplateRoute;
  FaxDraftsDraftIdCoverRoute: typeof FaxDraftsDraftIdCoverRoute;
  FaxDraftsDraftIdFinalizeRoute: typeof FaxDraftsDraftIdFinalizeRoute;
  FaxDraftsDraftIdUploadRoute: typeof FaxDraftsDraftIdUploadRoute;
}

const FaxDraftsDraftIdRouteChildren: FaxDraftsDraftIdRouteChildren = {
  FaxDraftsDraftIdBeginRoute: FaxDraftsDraftIdBeginRoute,
  FaxDraftsDraftIdChooseTemplateRoute: FaxDraftsDraftIdChooseTemplateRoute,
  FaxDraftsDraftIdCoverRoute: FaxDraftsDraftIdCoverRoute,
  FaxDraftsDraftIdFinalizeRoute: FaxDraftsDraftIdFinalizeRoute,
  FaxDraftsDraftIdUploadRoute: FaxDraftsDraftIdUploadRoute,
};

const FaxDraftsDraftIdRouteWithChildren = FaxDraftsDraftIdRoute._addFileChildren(FaxDraftsDraftIdRouteChildren);

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute;
  '/parent': typeof ParentRoute;
  '/insurance-eligibility-report': typeof PublicInsuranceEligibilityReportRoute;
  '/login': typeof PublicLoginRoute;
  '/password-reset': typeof PublicPasswordResetRoute;
  '/sign-in': typeof PublicSignInRoute;
  '/analytics/appointment': typeof AnalyticsAppointmentRoute;
  '/analytics/auto-recall': typeof AnalyticsAutoRecallRoute;
  '/analytics/call-intelligence': typeof AnalyticsCallIntelligenceRouteWithChildren;
  '/analytics/dashboard': typeof AnalyticsDashboardRoute;
  '/analytics/messaging': typeof AnalyticsMessagingRoute;
  '/analytics/phone': typeof AnalyticsPhoneRoute;
  '/analytics/practice': typeof AnalyticsPracticeRouteWithChildren;
  '/analytics/reviews': typeof AnalyticsReviewsRoute;
  '/analytics/roi': typeof AnalyticsRoiRouteWithChildren;
  '/bulk/$subNav': typeof BulkSubNavRoute;
  '/calls/call-history': typeof CallsCallHistoryRoute;
  '/calls/call-queue-stats': typeof CallsCallQueueStatsRoute;
  '/calls/voicemails': typeof CallsVoicemailsRoute;
  '/contacts/$filter': typeof ContactsFilterRoute;
  '/contacts/lists': typeof ContactsListsRoute;
  '/fax/$filter': typeof FaxFilterRouteWithChildren;
  '/home/dashboard': typeof HomeDashboardRoute;
  '/messages/$filter': typeof MessagesFilterRouteWithChildren;
  '/nr-auth-test/$id': typeof NrAuthTestIdRoute;
  '/payments/invoices': typeof PaymentsInvoicesRoute;
  '/payments/payment-plans': typeof PaymentsPaymentPlansRoute;
  '/payments/payouts': typeof PaymentsPayoutsRoute;
  '/payments/refunds': typeof PaymentsRefundsRoute;
  '/reviews/$site': typeof ReviewsSiteRouteWithChildren;
  '/schedule/calendar': typeof ScheduleCalendarRoute;
  '/schedule/quickfill-history': typeof ScheduleQuickfillHistoryRoute;
  '/schedule/request-history': typeof ScheduleRequestHistoryRoute;
  '/test/$id': typeof TestIdRoute;
  '/test/error': typeof TestErrorRoute;
  '/x/parent': typeof XParentRouteWithChildren;
  '/analytics': typeof AnalyticsIndexRoute;
  '/calls': typeof CallsIndexRoute;
  '/nr-public-test/$id': typeof PublicNrPublicTestIdRoute;
  '/reset-password/$nonceToken': typeof PublicResetPasswordNonceTokenRoute;
  '/sign-in/callback': typeof PublicSignInCallbackRoute;
  '/analytics/call-intelligence/$id': typeof AnalyticsCallIntelligenceIdRoute;
  '/analytics/call-intelligence/main': typeof AnalyticsCallIntelligenceMainRoute;
  '/analytics/practice/$feature': typeof AnalyticsPracticeFeatureRoute;
  '/analytics/practice/main': typeof AnalyticsPracticeMainRoute;
  '/analytics/roi/appointment-reminders': typeof AnalyticsRoiAppointmentRemindersRoute;
  '/analytics/roi/bulk-text': typeof AnalyticsRoiBulkTextRoute;
  '/analytics/roi/missed-call-text-conversion': typeof AnalyticsRoiMissedCallTextConversionRoute;
  '/analytics/roi/no-show-rate': typeof AnalyticsRoiNoShowRateRoute;
  '/bulk/$subNav/$type': typeof BulkSubNavTypeRoute;
  '/fax/$filter/$faxId': typeof FaxFilterFaxIdRoute;
  '/fax/drafts/$draftId': typeof FaxDraftsDraftIdRouteWithChildren;
  '/fax/drafts/new': typeof FaxDraftsNewRoute;
  '/fax/drafts/new-from-template': typeof FaxDraftsNewFromTemplateRoute;
  '/fax/drafts/template-editor': typeof FaxDraftsTemplateEditorRoute;
  '/messages/$filter/new': typeof MessagesFilterNewRoute;
  '/payments/invoices/$id': typeof PaymentsInvoicesIdRoute;
  '/payments/payment-plans/$planId': typeof PaymentsPaymentPlansPlanIdRoute;
  '/payments/payment-plans/create': typeof PaymentsPaymentPlansCreateRoute;
  '/payments/payouts/$payoutId': typeof PaymentsPayoutsPayoutIdRoute;
  '/payments/refunds/$invoiceId': typeof PaymentsRefundsInvoiceIdRoute;
  '/reviews/$site/$reviewId': typeof ReviewsSiteReviewIdRoute;
  '/x/parent/child': typeof XParentChildRoute;
  '/x/redirect/1': typeof XRedirect1Route;
  '/x/redirect/2': typeof XRedirect2Route;
  '/test/redirect/1': typeof PublicTestRedirect1Route;
  '/test/redirect/2': typeof PublicTestRedirect2Route;
  '/analytics/call-intelligence/follow-ups/$type': typeof AnalyticsCallIntelligenceFollowUpsTypeRoute;
  '/bulk/$subNav/$type/$id': typeof BulkSubNavTypeIdRoute;
  '/fax/drafts/$draftId/begin': typeof FaxDraftsDraftIdBeginRoute;
  '/fax/drafts/$draftId/choose-template': typeof FaxDraftsDraftIdChooseTemplateRoute;
  '/fax/drafts/$draftId/cover': typeof FaxDraftsDraftIdCoverRoute;
  '/fax/drafts/$draftId/finalize': typeof FaxDraftsDraftIdFinalizeRoute;
  '/fax/drafts/$draftId/upload': typeof FaxDraftsDraftIdUploadRoute;
  '/messages/$filter/$groupId/$threadId': typeof MessagesFilterGroupIdThreadIdRoute;
  '/accept-invite/$nonceToken/location/$locationId': typeof PublicAcceptInviteNonceTokenLocationLocationIdRoute;
  '/user-invite/$nonceToken/location/$locationId': typeof PublicUserInviteNonceTokenLocationLocationIdRoute;
  '/bulk/$subNav/$type/$id/$view': typeof BulkSubNavTypeIdViewRoute;
  '/calls/voicemail-boxes/$mailboxId/messages/$messageId': typeof CallsVoicemailBoxesMailboxIdMessagesMessageIdRoute;
}

export interface FileRoutesByTo {
  '/': typeof IndexRoute;
  '/parent': typeof ParentRoute;
  '/insurance-eligibility-report': typeof PublicInsuranceEligibilityReportRoute;
  '/login': typeof PublicLoginRoute;
  '/password-reset': typeof PublicPasswordResetRoute;
  '/sign-in': typeof PublicSignInRoute;
  '/analytics/appointment': typeof AnalyticsAppointmentRoute;
  '/analytics/auto-recall': typeof AnalyticsAutoRecallRoute;
  '/analytics/call-intelligence': typeof AnalyticsCallIntelligenceRouteWithChildren;
  '/analytics/dashboard': typeof AnalyticsDashboardRoute;
  '/analytics/messaging': typeof AnalyticsMessagingRoute;
  '/analytics/phone': typeof AnalyticsPhoneRoute;
  '/analytics/practice': typeof AnalyticsPracticeRouteWithChildren;
  '/analytics/reviews': typeof AnalyticsReviewsRoute;
  '/analytics/roi': typeof AnalyticsRoiRouteWithChildren;
  '/bulk/$subNav': typeof BulkSubNavRoute;
  '/calls/call-history': typeof CallsCallHistoryRoute;
  '/calls/call-queue-stats': typeof CallsCallQueueStatsRoute;
  '/calls/voicemails': typeof CallsVoicemailsRoute;
  '/contacts/$filter': typeof ContactsFilterRoute;
  '/contacts/lists': typeof ContactsListsRoute;
  '/fax/$filter': typeof FaxFilterRouteWithChildren;
  '/home/dashboard': typeof HomeDashboardRoute;
  '/messages/$filter': typeof MessagesFilterRouteWithChildren;
  '/nr-auth-test/$id': typeof NrAuthTestIdRoute;
  '/payments/invoices': typeof PaymentsInvoicesRoute;
  '/payments/payment-plans': typeof PaymentsPaymentPlansRoute;
  '/payments/payouts': typeof PaymentsPayoutsRoute;
  '/payments/refunds': typeof PaymentsRefundsRoute;
  '/reviews/$site': typeof ReviewsSiteRouteWithChildren;
  '/schedule/calendar': typeof ScheduleCalendarRoute;
  '/schedule/quickfill-history': typeof ScheduleQuickfillHistoryRoute;
  '/schedule/request-history': typeof ScheduleRequestHistoryRoute;
  '/test/$id': typeof TestIdRoute;
  '/test/error': typeof TestErrorRoute;
  '/x/parent': typeof XParentRouteWithChildren;
  '/analytics': typeof AnalyticsIndexRoute;
  '/calls': typeof CallsIndexRoute;
  '/nr-public-test/$id': typeof PublicNrPublicTestIdRoute;
  '/reset-password/$nonceToken': typeof PublicResetPasswordNonceTokenRoute;
  '/sign-in/callback': typeof PublicSignInCallbackRoute;
  '/analytics/call-intelligence/$id': typeof AnalyticsCallIntelligenceIdRoute;
  '/analytics/call-intelligence/main': typeof AnalyticsCallIntelligenceMainRoute;
  '/analytics/practice/$feature': typeof AnalyticsPracticeFeatureRoute;
  '/analytics/practice/main': typeof AnalyticsPracticeMainRoute;
  '/analytics/roi/appointment-reminders': typeof AnalyticsRoiAppointmentRemindersRoute;
  '/analytics/roi/bulk-text': typeof AnalyticsRoiBulkTextRoute;
  '/analytics/roi/missed-call-text-conversion': typeof AnalyticsRoiMissedCallTextConversionRoute;
  '/analytics/roi/no-show-rate': typeof AnalyticsRoiNoShowRateRoute;
  '/bulk/$subNav/$type': typeof BulkSubNavTypeRoute;
  '/fax/$filter/$faxId': typeof FaxFilterFaxIdRoute;
  '/fax/drafts/$draftId': typeof FaxDraftsDraftIdRouteWithChildren;
  '/fax/drafts/new': typeof FaxDraftsNewRoute;
  '/fax/drafts/new-from-template': typeof FaxDraftsNewFromTemplateRoute;
  '/fax/drafts/template-editor': typeof FaxDraftsTemplateEditorRoute;
  '/messages/$filter/new': typeof MessagesFilterNewRoute;
  '/payments/invoices/$id': typeof PaymentsInvoicesIdRoute;
  '/payments/payment-plans/$planId': typeof PaymentsPaymentPlansPlanIdRoute;
  '/payments/payment-plans/create': typeof PaymentsPaymentPlansCreateRoute;
  '/payments/payouts/$payoutId': typeof PaymentsPayoutsPayoutIdRoute;
  '/payments/refunds/$invoiceId': typeof PaymentsRefundsInvoiceIdRoute;
  '/reviews/$site/$reviewId': typeof ReviewsSiteReviewIdRoute;
  '/x/parent/child': typeof XParentChildRoute;
  '/x/redirect/1': typeof XRedirect1Route;
  '/x/redirect/2': typeof XRedirect2Route;
  '/test/redirect/1': typeof PublicTestRedirect1Route;
  '/test/redirect/2': typeof PublicTestRedirect2Route;
  '/analytics/call-intelligence/follow-ups/$type': typeof AnalyticsCallIntelligenceFollowUpsTypeRoute;
  '/bulk/$subNav/$type/$id': typeof BulkSubNavTypeIdRoute;
  '/fax/drafts/$draftId/begin': typeof FaxDraftsDraftIdBeginRoute;
  '/fax/drafts/$draftId/choose-template': typeof FaxDraftsDraftIdChooseTemplateRoute;
  '/fax/drafts/$draftId/cover': typeof FaxDraftsDraftIdCoverRoute;
  '/fax/drafts/$draftId/finalize': typeof FaxDraftsDraftIdFinalizeRoute;
  '/fax/drafts/$draftId/upload': typeof FaxDraftsDraftIdUploadRoute;
  '/messages/$filter/$groupId/$threadId': typeof MessagesFilterGroupIdThreadIdRoute;
  '/accept-invite/$nonceToken/location/$locationId': typeof PublicAcceptInviteNonceTokenLocationLocationIdRoute;
  '/user-invite/$nonceToken/location/$locationId': typeof PublicUserInviteNonceTokenLocationLocationIdRoute;
  '/bulk/$subNav/$type/$id/$view': typeof BulkSubNavTypeIdViewRoute;
  '/calls/voicemail-boxes/$mailboxId/messages/$messageId': typeof CallsVoicemailBoxesMailboxIdMessagesMessageIdRoute;
}

export interface FileRoutesById {
  __root__: typeof rootRoute;
  '/': typeof IndexRoute;
  '/parent': typeof ParentRoute;
  '/_public/insurance-eligibility-report': typeof PublicInsuranceEligibilityReportRoute;
  '/_public/login': typeof PublicLoginRoute;
  '/_public/password-reset': typeof PublicPasswordResetRoute;
  '/_public/sign-in': typeof PublicSignInRoute;
  '/analytics/appointment': typeof AnalyticsAppointmentRoute;
  '/analytics/auto-recall': typeof AnalyticsAutoRecallRoute;
  '/analytics/call-intelligence': typeof AnalyticsCallIntelligenceRouteWithChildren;
  '/analytics/dashboard': typeof AnalyticsDashboardRoute;
  '/analytics/messaging': typeof AnalyticsMessagingRoute;
  '/analytics/phone': typeof AnalyticsPhoneRoute;
  '/analytics/practice': typeof AnalyticsPracticeRouteWithChildren;
  '/analytics/reviews': typeof AnalyticsReviewsRoute;
  '/analytics/roi': typeof AnalyticsRoiRouteWithChildren;
  '/bulk_/$subNav': typeof BulkSubNavRoute;
  '/calls/call-history': typeof CallsCallHistoryRoute;
  '/calls/call-queue-stats': typeof CallsCallQueueStatsRoute;
  '/calls/voicemails': typeof CallsVoicemailsRoute;
  '/contacts/$filter': typeof ContactsFilterRoute;
  '/contacts/lists': typeof ContactsListsRoute;
  '/fax/$filter': typeof FaxFilterRouteWithChildren;
  '/home/dashboard': typeof HomeDashboardRoute;
  '/messages/$filter': typeof MessagesFilterRouteWithChildren;
  '/nr-auth-test/$id': typeof NrAuthTestIdRoute;
  '/payments/invoices': typeof PaymentsInvoicesRoute;
  '/payments/payment-plans': typeof PaymentsPaymentPlansRoute;
  '/payments/payouts': typeof PaymentsPayoutsRoute;
  '/payments/refunds': typeof PaymentsRefundsRoute;
  '/reviews/$site': typeof ReviewsSiteRouteWithChildren;
  '/schedule/calendar': typeof ScheduleCalendarRoute;
  '/schedule/quickfill-history': typeof ScheduleQuickfillHistoryRoute;
  '/schedule/request-history': typeof ScheduleRequestHistoryRoute;
  '/test/$id': typeof TestIdRoute;
  '/test_/error': typeof TestErrorRoute;
  '/x_/parent': typeof XParentRouteWithChildren;
  '/analytics/': typeof AnalyticsIndexRoute;
  '/calls/': typeof CallsIndexRoute;
  '/_public/nr-public-test/$id': typeof PublicNrPublicTestIdRoute;
  '/_public/reset-password_/$nonceToken': typeof PublicResetPasswordNonceTokenRoute;
  '/_public/sign-in_/callback': typeof PublicSignInCallbackRoute;
  '/analytics/call-intelligence/$id': typeof AnalyticsCallIntelligenceIdRoute;
  '/analytics/call-intelligence/main': typeof AnalyticsCallIntelligenceMainRoute;
  '/analytics/practice/$feature': typeof AnalyticsPracticeFeatureRoute;
  '/analytics/practice/main': typeof AnalyticsPracticeMainRoute;
  '/analytics/roi/appointment-reminders': typeof AnalyticsRoiAppointmentRemindersRoute;
  '/analytics/roi/bulk-text': typeof AnalyticsRoiBulkTextRoute;
  '/analytics/roi/missed-call-text-conversion': typeof AnalyticsRoiMissedCallTextConversionRoute;
  '/analytics/roi/no-show-rate': typeof AnalyticsRoiNoShowRateRoute;
  '/bulk_/$subNav_/$type': typeof BulkSubNavTypeRoute;
  '/fax/$filter/$faxId': typeof FaxFilterFaxIdRoute;
  '/fax/drafts/$draftId': typeof FaxDraftsDraftIdRouteWithChildren;
  '/fax/drafts/new': typeof FaxDraftsNewRoute;
  '/fax/drafts/new-from-template': typeof FaxDraftsNewFromTemplateRoute;
  '/fax/drafts/template-editor': typeof FaxDraftsTemplateEditorRoute;
  '/messages/$filter/new': typeof MessagesFilterNewRoute;
  '/payments/invoices_/$id': typeof PaymentsInvoicesIdRoute;
  '/payments/payment-plans_/$planId': typeof PaymentsPaymentPlansPlanIdRoute;
  '/payments/payment-plans_/create': typeof PaymentsPaymentPlansCreateRoute;
  '/payments/payouts_/$payoutId': typeof PaymentsPayoutsPayoutIdRoute;
  '/payments/refunds_/$invoiceId': typeof PaymentsRefundsInvoiceIdRoute;
  '/reviews/$site/$reviewId': typeof ReviewsSiteReviewIdRoute;
  '/x_/parent/child': typeof XParentChildRoute;
  '/x_/redirect_/1': typeof XRedirect1Route;
  '/x_/redirect_/2': typeof XRedirect2Route;
  '/_public/test_/redirect_/1': typeof PublicTestRedirect1Route;
  '/_public/test_/redirect_/2': typeof PublicTestRedirect2Route;
  '/analytics/call-intelligence/follow-ups_/$type': typeof AnalyticsCallIntelligenceFollowUpsTypeRoute;
  '/bulk_/$subNav_/$type_/$id': typeof BulkSubNavTypeIdRoute;
  '/fax/drafts/$draftId/begin': typeof FaxDraftsDraftIdBeginRoute;
  '/fax/drafts/$draftId/choose-template': typeof FaxDraftsDraftIdChooseTemplateRoute;
  '/fax/drafts/$draftId/cover': typeof FaxDraftsDraftIdCoverRoute;
  '/fax/drafts/$draftId/finalize': typeof FaxDraftsDraftIdFinalizeRoute;
  '/fax/drafts/$draftId/upload': typeof FaxDraftsDraftIdUploadRoute;
  '/messages/$filter/$groupId_/$threadId': typeof MessagesFilterGroupIdThreadIdRoute;
  '/_public/accept-invite_/$nonceToken_/location_/$locationId': typeof PublicAcceptInviteNonceTokenLocationLocationIdRoute;
  '/_public/user-invite_/$nonceToken_/location_/$locationId': typeof PublicUserInviteNonceTokenLocationLocationIdRoute;
  '/bulk_/$subNav_/$type_/$id_/$view': typeof BulkSubNavTypeIdViewRoute;
  '/calls/voicemail-boxes/$mailboxId/messages/$messageId': typeof CallsVoicemailBoxesMailboxIdMessagesMessageIdRoute;
}

export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath;
  fullPaths:
    | '/'
    | '/parent'
    | '/insurance-eligibility-report'
    | '/login'
    | '/password-reset'
    | '/sign-in'
    | '/analytics/appointment'
    | '/analytics/auto-recall'
    | '/analytics/call-intelligence'
    | '/analytics/dashboard'
    | '/analytics/messaging'
    | '/analytics/phone'
    | '/analytics/practice'
    | '/analytics/reviews'
    | '/analytics/roi'
    | '/bulk/$subNav'
    | '/calls/call-history'
    | '/calls/call-queue-stats'
    | '/calls/voicemails'
    | '/contacts/$filter'
    | '/contacts/lists'
    | '/fax/$filter'
    | '/home/dashboard'
    | '/messages/$filter'
    | '/nr-auth-test/$id'
    | '/payments/invoices'
    | '/payments/payment-plans'
    | '/payments/payouts'
    | '/payments/refunds'
    | '/reviews/$site'
    | '/schedule/calendar'
    | '/schedule/quickfill-history'
    | '/schedule/request-history'
    | '/test/$id'
    | '/test/error'
    | '/x/parent'
    | '/analytics'
    | '/calls'
    | '/nr-public-test/$id'
    | '/reset-password/$nonceToken'
    | '/sign-in/callback'
    | '/analytics/call-intelligence/$id'
    | '/analytics/call-intelligence/main'
    | '/analytics/practice/$feature'
    | '/analytics/practice/main'
    | '/analytics/roi/appointment-reminders'
    | '/analytics/roi/bulk-text'
    | '/analytics/roi/missed-call-text-conversion'
    | '/analytics/roi/no-show-rate'
    | '/bulk/$subNav/$type'
    | '/fax/$filter/$faxId'
    | '/fax/drafts/$draftId'
    | '/fax/drafts/new'
    | '/fax/drafts/new-from-template'
    | '/fax/drafts/template-editor'
    | '/messages/$filter/new'
    | '/payments/invoices/$id'
    | '/payments/payment-plans/$planId'
    | '/payments/payment-plans/create'
    | '/payments/payouts/$payoutId'
    | '/payments/refunds/$invoiceId'
    | '/reviews/$site/$reviewId'
    | '/x/parent/child'
    | '/x/redirect/1'
    | '/x/redirect/2'
    | '/test/redirect/1'
    | '/test/redirect/2'
    | '/analytics/call-intelligence/follow-ups/$type'
    | '/bulk/$subNav/$type/$id'
    | '/fax/drafts/$draftId/begin'
    | '/fax/drafts/$draftId/choose-template'
    | '/fax/drafts/$draftId/cover'
    | '/fax/drafts/$draftId/finalize'
    | '/fax/drafts/$draftId/upload'
    | '/messages/$filter/$groupId/$threadId'
    | '/accept-invite/$nonceToken/location/$locationId'
    | '/user-invite/$nonceToken/location/$locationId'
    | '/bulk/$subNav/$type/$id/$view'
    | '/calls/voicemail-boxes/$mailboxId/messages/$messageId';
  fileRoutesByTo: FileRoutesByTo;
  to:
    | '/'
    | '/parent'
    | '/insurance-eligibility-report'
    | '/login'
    | '/password-reset'
    | '/sign-in'
    | '/analytics/appointment'
    | '/analytics/auto-recall'
    | '/analytics/call-intelligence'
    | '/analytics/dashboard'
    | '/analytics/messaging'
    | '/analytics/phone'
    | '/analytics/practice'
    | '/analytics/reviews'
    | '/analytics/roi'
    | '/bulk/$subNav'
    | '/calls/call-history'
    | '/calls/call-queue-stats'
    | '/calls/voicemails'
    | '/contacts/$filter'
    | '/contacts/lists'
    | '/fax/$filter'
    | '/home/dashboard'
    | '/messages/$filter'
    | '/nr-auth-test/$id'
    | '/payments/invoices'
    | '/payments/payment-plans'
    | '/payments/payouts'
    | '/payments/refunds'
    | '/reviews/$site'
    | '/schedule/calendar'
    | '/schedule/quickfill-history'
    | '/schedule/request-history'
    | '/test/$id'
    | '/test/error'
    | '/x/parent'
    | '/analytics'
    | '/calls'
    | '/nr-public-test/$id'
    | '/reset-password/$nonceToken'
    | '/sign-in/callback'
    | '/analytics/call-intelligence/$id'
    | '/analytics/call-intelligence/main'
    | '/analytics/practice/$feature'
    | '/analytics/practice/main'
    | '/analytics/roi/appointment-reminders'
    | '/analytics/roi/bulk-text'
    | '/analytics/roi/missed-call-text-conversion'
    | '/analytics/roi/no-show-rate'
    | '/bulk/$subNav/$type'
    | '/fax/$filter/$faxId'
    | '/fax/drafts/$draftId'
    | '/fax/drafts/new'
    | '/fax/drafts/new-from-template'
    | '/fax/drafts/template-editor'
    | '/messages/$filter/new'
    | '/payments/invoices/$id'
    | '/payments/payment-plans/$planId'
    | '/payments/payment-plans/create'
    | '/payments/payouts/$payoutId'
    | '/payments/refunds/$invoiceId'
    | '/reviews/$site/$reviewId'
    | '/x/parent/child'
    | '/x/redirect/1'
    | '/x/redirect/2'
    | '/test/redirect/1'
    | '/test/redirect/2'
    | '/analytics/call-intelligence/follow-ups/$type'
    | '/bulk/$subNav/$type/$id'
    | '/fax/drafts/$draftId/begin'
    | '/fax/drafts/$draftId/choose-template'
    | '/fax/drafts/$draftId/cover'
    | '/fax/drafts/$draftId/finalize'
    | '/fax/drafts/$draftId/upload'
    | '/messages/$filter/$groupId/$threadId'
    | '/accept-invite/$nonceToken/location/$locationId'
    | '/user-invite/$nonceToken/location/$locationId'
    | '/bulk/$subNav/$type/$id/$view'
    | '/calls/voicemail-boxes/$mailboxId/messages/$messageId';
  id:
    | '__root__'
    | '/'
    | '/parent'
    | '/_public/insurance-eligibility-report'
    | '/_public/login'
    | '/_public/password-reset'
    | '/_public/sign-in'
    | '/analytics/appointment'
    | '/analytics/auto-recall'
    | '/analytics/call-intelligence'
    | '/analytics/dashboard'
    | '/analytics/messaging'
    | '/analytics/phone'
    | '/analytics/practice'
    | '/analytics/reviews'
    | '/analytics/roi'
    | '/bulk_/$subNav'
    | '/calls/call-history'
    | '/calls/call-queue-stats'
    | '/calls/voicemails'
    | '/contacts/$filter'
    | '/contacts/lists'
    | '/fax/$filter'
    | '/home/dashboard'
    | '/messages/$filter'
    | '/nr-auth-test/$id'
    | '/payments/invoices'
    | '/payments/payment-plans'
    | '/payments/payouts'
    | '/payments/refunds'
    | '/reviews/$site'
    | '/schedule/calendar'
    | '/schedule/quickfill-history'
    | '/schedule/request-history'
    | '/test/$id'
    | '/test_/error'
    | '/x_/parent'
    | '/analytics/'
    | '/calls/'
    | '/_public/nr-public-test/$id'
    | '/_public/reset-password_/$nonceToken'
    | '/_public/sign-in_/callback'
    | '/analytics/call-intelligence/$id'
    | '/analytics/call-intelligence/main'
    | '/analytics/practice/$feature'
    | '/analytics/practice/main'
    | '/analytics/roi/appointment-reminders'
    | '/analytics/roi/bulk-text'
    | '/analytics/roi/missed-call-text-conversion'
    | '/analytics/roi/no-show-rate'
    | '/bulk_/$subNav_/$type'
    | '/fax/$filter/$faxId'
    | '/fax/drafts/$draftId'
    | '/fax/drafts/new'
    | '/fax/drafts/new-from-template'
    | '/fax/drafts/template-editor'
    | '/messages/$filter/new'
    | '/payments/invoices_/$id'
    | '/payments/payment-plans_/$planId'
    | '/payments/payment-plans_/create'
    | '/payments/payouts_/$payoutId'
    | '/payments/refunds_/$invoiceId'
    | '/reviews/$site/$reviewId'
    | '/x_/parent/child'
    | '/x_/redirect_/1'
    | '/x_/redirect_/2'
    | '/_public/test_/redirect_/1'
    | '/_public/test_/redirect_/2'
    | '/analytics/call-intelligence/follow-ups_/$type'
    | '/bulk_/$subNav_/$type_/$id'
    | '/fax/drafts/$draftId/begin'
    | '/fax/drafts/$draftId/choose-template'
    | '/fax/drafts/$draftId/cover'
    | '/fax/drafts/$draftId/finalize'
    | '/fax/drafts/$draftId/upload'
    | '/messages/$filter/$groupId_/$threadId'
    | '/_public/accept-invite_/$nonceToken_/location_/$locationId'
    | '/_public/user-invite_/$nonceToken_/location_/$locationId'
    | '/bulk_/$subNav_/$type_/$id_/$view'
    | '/calls/voicemail-boxes/$mailboxId/messages/$messageId';
  fileRoutesById: FileRoutesById;
}

export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute;
  ParentRoute: typeof ParentRoute;
  PublicInsuranceEligibilityReportRoute: typeof PublicInsuranceEligibilityReportRoute;
  PublicLoginRoute: typeof PublicLoginRoute;
  PublicPasswordResetRoute: typeof PublicPasswordResetRoute;
  PublicSignInRoute: typeof PublicSignInRoute;
  AnalyticsAppointmentRoute: typeof AnalyticsAppointmentRoute;
  AnalyticsAutoRecallRoute: typeof AnalyticsAutoRecallRoute;
  AnalyticsCallIntelligenceRoute: typeof AnalyticsCallIntelligenceRouteWithChildren;
  AnalyticsDashboardRoute: typeof AnalyticsDashboardRoute;
  AnalyticsMessagingRoute: typeof AnalyticsMessagingRoute;
  AnalyticsPhoneRoute: typeof AnalyticsPhoneRoute;
  AnalyticsPracticeRoute: typeof AnalyticsPracticeRouteWithChildren;
  AnalyticsReviewsRoute: typeof AnalyticsReviewsRoute;
  AnalyticsRoiRoute: typeof AnalyticsRoiRouteWithChildren;
  BulkSubNavRoute: typeof BulkSubNavRoute;
  CallsCallHistoryRoute: typeof CallsCallHistoryRoute;
  CallsCallQueueStatsRoute: typeof CallsCallQueueStatsRoute;
  CallsVoicemailsRoute: typeof CallsVoicemailsRoute;
  ContactsFilterRoute: typeof ContactsFilterRoute;
  ContactsListsRoute: typeof ContactsListsRoute;
  FaxFilterRoute: typeof FaxFilterRouteWithChildren;
  HomeDashboardRoute: typeof HomeDashboardRoute;
  MessagesFilterRoute: typeof MessagesFilterRouteWithChildren;
  NrAuthTestIdRoute: typeof NrAuthTestIdRoute;
  PaymentsInvoicesRoute: typeof PaymentsInvoicesRoute;
  PaymentsPaymentPlansRoute: typeof PaymentsPaymentPlansRoute;
  PaymentsPayoutsRoute: typeof PaymentsPayoutsRoute;
  PaymentsRefundsRoute: typeof PaymentsRefundsRoute;
  ReviewsSiteRoute: typeof ReviewsSiteRouteWithChildren;
  ScheduleCalendarRoute: typeof ScheduleCalendarRoute;
  ScheduleQuickfillHistoryRoute: typeof ScheduleQuickfillHistoryRoute;
  ScheduleRequestHistoryRoute: typeof ScheduleRequestHistoryRoute;
  TestIdRoute: typeof TestIdRoute;
  TestErrorRoute: typeof TestErrorRoute;
  XParentRoute: typeof XParentRouteWithChildren;
  AnalyticsIndexRoute: typeof AnalyticsIndexRoute;
  CallsIndexRoute: typeof CallsIndexRoute;
  PublicNrPublicTestIdRoute: typeof PublicNrPublicTestIdRoute;
  PublicResetPasswordNonceTokenRoute: typeof PublicResetPasswordNonceTokenRoute;
  PublicSignInCallbackRoute: typeof PublicSignInCallbackRoute;
  BulkSubNavTypeRoute: typeof BulkSubNavTypeRoute;
  FaxDraftsDraftIdRoute: typeof FaxDraftsDraftIdRouteWithChildren;
  FaxDraftsNewRoute: typeof FaxDraftsNewRoute;
  FaxDraftsNewFromTemplateRoute: typeof FaxDraftsNewFromTemplateRoute;
  FaxDraftsTemplateEditorRoute: typeof FaxDraftsTemplateEditorRoute;
  PaymentsInvoicesIdRoute: typeof PaymentsInvoicesIdRoute;
  PaymentsPaymentPlansPlanIdRoute: typeof PaymentsPaymentPlansPlanIdRoute;
  PaymentsPaymentPlansCreateRoute: typeof PaymentsPaymentPlansCreateRoute;
  PaymentsPayoutsPayoutIdRoute: typeof PaymentsPayoutsPayoutIdRoute;
  PaymentsRefundsInvoiceIdRoute: typeof PaymentsRefundsInvoiceIdRoute;
  XRedirect1Route: typeof XRedirect1Route;
  XRedirect2Route: typeof XRedirect2Route;
  PublicTestRedirect1Route: typeof PublicTestRedirect1Route;
  PublicTestRedirect2Route: typeof PublicTestRedirect2Route;
  BulkSubNavTypeIdRoute: typeof BulkSubNavTypeIdRoute;
  PublicAcceptInviteNonceTokenLocationLocationIdRoute: typeof PublicAcceptInviteNonceTokenLocationLocationIdRoute;
  PublicUserInviteNonceTokenLocationLocationIdRoute: typeof PublicUserInviteNonceTokenLocationLocationIdRoute;
  BulkSubNavTypeIdViewRoute: typeof BulkSubNavTypeIdViewRoute;
  CallsVoicemailBoxesMailboxIdMessagesMessageIdRoute: typeof CallsVoicemailBoxesMailboxIdMessagesMessageIdRoute;
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  ParentRoute: ParentRoute,
  PublicInsuranceEligibilityReportRoute: PublicInsuranceEligibilityReportRoute,
  PublicLoginRoute: PublicLoginRoute,
  PublicPasswordResetRoute: PublicPasswordResetRoute,
  PublicSignInRoute: PublicSignInRoute,
  AnalyticsAppointmentRoute: AnalyticsAppointmentRoute,
  AnalyticsAutoRecallRoute: AnalyticsAutoRecallRoute,
  AnalyticsCallIntelligenceRoute: AnalyticsCallIntelligenceRouteWithChildren,
  AnalyticsDashboardRoute: AnalyticsDashboardRoute,
  AnalyticsMessagingRoute: AnalyticsMessagingRoute,
  AnalyticsPhoneRoute: AnalyticsPhoneRoute,
  AnalyticsPracticeRoute: AnalyticsPracticeRouteWithChildren,
  AnalyticsReviewsRoute: AnalyticsReviewsRoute,
  AnalyticsRoiRoute: AnalyticsRoiRouteWithChildren,
  BulkSubNavRoute: BulkSubNavRoute,
  CallsCallHistoryRoute: CallsCallHistoryRoute,
  CallsCallQueueStatsRoute: CallsCallQueueStatsRoute,
  CallsVoicemailsRoute: CallsVoicemailsRoute,
  ContactsFilterRoute: ContactsFilterRoute,
  ContactsListsRoute: ContactsListsRoute,
  FaxFilterRoute: FaxFilterRouteWithChildren,
  HomeDashboardRoute: HomeDashboardRoute,
  MessagesFilterRoute: MessagesFilterRouteWithChildren,
  NrAuthTestIdRoute: NrAuthTestIdRoute,
  PaymentsInvoicesRoute: PaymentsInvoicesRoute,
  PaymentsPaymentPlansRoute: PaymentsPaymentPlansRoute,
  PaymentsPayoutsRoute: PaymentsPayoutsRoute,
  PaymentsRefundsRoute: PaymentsRefundsRoute,
  ReviewsSiteRoute: ReviewsSiteRouteWithChildren,
  ScheduleCalendarRoute: ScheduleCalendarRoute,
  ScheduleQuickfillHistoryRoute: ScheduleQuickfillHistoryRoute,
  ScheduleRequestHistoryRoute: ScheduleRequestHistoryRoute,
  TestIdRoute: TestIdRoute,
  TestErrorRoute: TestErrorRoute,
  XParentRoute: XParentRouteWithChildren,
  AnalyticsIndexRoute: AnalyticsIndexRoute,
  CallsIndexRoute: CallsIndexRoute,
  PublicNrPublicTestIdRoute: PublicNrPublicTestIdRoute,
  PublicResetPasswordNonceTokenRoute: PublicResetPasswordNonceTokenRoute,
  PublicSignInCallbackRoute: PublicSignInCallbackRoute,
  BulkSubNavTypeRoute: BulkSubNavTypeRoute,
  FaxDraftsDraftIdRoute: FaxDraftsDraftIdRouteWithChildren,
  FaxDraftsNewRoute: FaxDraftsNewRoute,
  FaxDraftsNewFromTemplateRoute: FaxDraftsNewFromTemplateRoute,
  FaxDraftsTemplateEditorRoute: FaxDraftsTemplateEditorRoute,
  PaymentsInvoicesIdRoute: PaymentsInvoicesIdRoute,
  PaymentsPaymentPlansPlanIdRoute: PaymentsPaymentPlansPlanIdRoute,
  PaymentsPaymentPlansCreateRoute: PaymentsPaymentPlansCreateRoute,
  PaymentsPayoutsPayoutIdRoute: PaymentsPayoutsPayoutIdRoute,
  PaymentsRefundsInvoiceIdRoute: PaymentsRefundsInvoiceIdRoute,
  XRedirect1Route: XRedirect1Route,
  XRedirect2Route: XRedirect2Route,
  PublicTestRedirect1Route: PublicTestRedirect1Route,
  PublicTestRedirect2Route: PublicTestRedirect2Route,
  BulkSubNavTypeIdRoute: BulkSubNavTypeIdRoute,
  PublicAcceptInviteNonceTokenLocationLocationIdRoute: PublicAcceptInviteNonceTokenLocationLocationIdRoute,
  PublicUserInviteNonceTokenLocationLocationIdRoute: PublicUserInviteNonceTokenLocationLocationIdRoute,
  BulkSubNavTypeIdViewRoute: BulkSubNavTypeIdViewRoute,
  CallsVoicemailBoxesMailboxIdMessagesMessageIdRoute: CallsVoicemailBoxesMailboxIdMessagesMessageIdRoute,
};

export const routeTree = rootRoute._addFileChildren(rootRouteChildren)._addFileTypes<FileRouteTypes>();

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/",
        "/parent",
        "/_public/insurance-eligibility-report",
        "/_public/login",
        "/_public/password-reset",
        "/_public/sign-in",
        "/analytics/appointment",
        "/analytics/auto-recall",
        "/analytics/call-intelligence",
        "/analytics/dashboard",
        "/analytics/messaging",
        "/analytics/phone",
        "/analytics/practice",
        "/analytics/reviews",
        "/analytics/roi",
        "/bulk_/$subNav",
        "/calls/call-history",
        "/calls/call-queue-stats",
        "/calls/voicemails",
        "/contacts/$filter",
        "/contacts/lists",
        "/fax/$filter",
        "/home/dashboard",
        "/messages/$filter",
        "/nr-auth-test/$id",
        "/payments/invoices",
        "/payments/payment-plans",
        "/payments/payouts",
        "/payments/refunds",
        "/reviews/$site",
        "/schedule/calendar",
        "/schedule/quickfill-history",
        "/schedule/request-history",
        "/test/$id",
        "/test_/error",
        "/x_/parent",
        "/analytics/",
        "/calls/",
        "/_public/nr-public-test/$id",
        "/_public/reset-password_/$nonceToken",
        "/_public/sign-in_/callback",
        "/bulk_/$subNav_/$type",
        "/fax/drafts/$draftId",
        "/fax/drafts/new",
        "/fax/drafts/new-from-template",
        "/fax/drafts/template-editor",
        "/payments/invoices_/$id",
        "/payments/payment-plans_/$planId",
        "/payments/payment-plans_/create",
        "/payments/payouts_/$payoutId",
        "/payments/refunds_/$invoiceId",
        "/x_/redirect_/1",
        "/x_/redirect_/2",
        "/_public/test_/redirect_/1",
        "/_public/test_/redirect_/2",
        "/bulk_/$subNav_/$type_/$id",
        "/_public/accept-invite_/$nonceToken_/location_/$locationId",
        "/_public/user-invite_/$nonceToken_/location_/$locationId",
        "/bulk_/$subNav_/$type_/$id_/$view",
        "/calls/voicemail-boxes/$mailboxId/messages/$messageId"
      ]
    },
    "/": {
      "filePath": "index.tsx"
    },
    "/parent": {
      "filePath": "parent.tsx"
    },
    "/_public/insurance-eligibility-report": {
      "filePath": "_public/insurance-eligibility-report.tsx"
    },
    "/_public/login": {
      "filePath": "_public/login.tsx"
    },
    "/_public/password-reset": {
      "filePath": "_public/password-reset.tsx"
    },
    "/_public/sign-in": {
      "filePath": "_public/sign-in.tsx"
    },
    "/analytics/appointment": {
      "filePath": "analytics/appointment.tsx"
    },
    "/analytics/auto-recall": {
      "filePath": "analytics/auto-recall.tsx"
    },
    "/analytics/call-intelligence": {
      "filePath": "analytics/call-intelligence.tsx",
      "children": [
        "/analytics/call-intelligence/$id",
        "/analytics/call-intelligence/main",
        "/analytics/call-intelligence/follow-ups_/$type"
      ]
    },
    "/analytics/dashboard": {
      "filePath": "analytics/dashboard.tsx"
    },
    "/analytics/messaging": {
      "filePath": "analytics/messaging.tsx"
    },
    "/analytics/phone": {
      "filePath": "analytics/phone.tsx"
    },
    "/analytics/practice": {
      "filePath": "analytics/practice.tsx",
      "children": [
        "/analytics/practice/$feature",
        "/analytics/practice/main"
      ]
    },
    "/analytics/reviews": {
      "filePath": "analytics/reviews.tsx"
    },
    "/analytics/roi": {
      "filePath": "analytics/roi.tsx",
      "children": [
        "/analytics/roi/appointment-reminders",
        "/analytics/roi/bulk-text",
        "/analytics/roi/missed-call-text-conversion",
        "/analytics/roi/no-show-rate"
      ]
    },
    "/bulk_/$subNav": {
      "filePath": "bulk_/$subNav.tsx"
    },
    "/calls/call-history": {
      "filePath": "calls/call-history.tsx"
    },
    "/calls/call-queue-stats": {
      "filePath": "calls/call-queue-stats.tsx"
    },
    "/calls/voicemails": {
      "filePath": "calls/voicemails.tsx"
    },
    "/contacts/$filter": {
      "filePath": "contacts/$filter.tsx"
    },
    "/contacts/lists": {
      "filePath": "contacts/lists.tsx"
    },
    "/fax/$filter": {
      "filePath": "fax/$filter.tsx",
      "children": [
        "/fax/$filter/$faxId"
      ]
    },
    "/home/dashboard": {
      "filePath": "home/dashboard.tsx"
    },
    "/messages/$filter": {
      "filePath": "messages/$filter.tsx",
      "children": [
        "/messages/$filter/new",
        "/messages/$filter/$groupId_/$threadId"
      ]
    },
    "/nr-auth-test/$id": {
      "filePath": "nr-auth-test.$id.tsx"
    },
    "/payments/invoices": {
      "filePath": "payments/invoices.tsx"
    },
    "/payments/payment-plans": {
      "filePath": "payments/payment-plans.tsx"
    },
    "/payments/payouts": {
      "filePath": "payments/payouts.tsx"
    },
    "/payments/refunds": {
      "filePath": "payments/refunds.tsx"
    },
    "/reviews/$site": {
      "filePath": "reviews/$site.tsx",
      "children": [
        "/reviews/$site/$reviewId"
      ]
    },
    "/schedule/calendar": {
      "filePath": "schedule/calendar.tsx"
    },
    "/schedule/quickfill-history": {
      "filePath": "schedule/quickfill-history.tsx"
    },
    "/schedule/request-history": {
      "filePath": "schedule/request-history.tsx"
    },
    "/test/$id": {
      "filePath": "test.$id.tsx"
    },
    "/test_/error": {
      "filePath": "test_.error.tsx"
    },
    "/x_/parent": {
      "filePath": "x_/parent.tsx",
      "children": [
        "/x_/parent/child"
      ]
    },
    "/analytics/": {
      "filePath": "analytics/index.tsx"
    },
    "/calls/": {
      "filePath": "calls/index.tsx"
    },
    "/_public/nr-public-test/$id": {
      "filePath": "_public/nr-public-test.$id.tsx"
    },
    "/_public/reset-password_/$nonceToken": {
      "filePath": "_public/reset-password_/$nonceToken.tsx"
    },
    "/_public/sign-in_/callback": {
      "filePath": "_public/sign-in_.callback.tsx"
    },
    "/analytics/call-intelligence/$id": {
      "filePath": "analytics/call-intelligence.$id.tsx",
      "parent": "/analytics/call-intelligence"
    },
    "/analytics/call-intelligence/main": {
      "filePath": "analytics/call-intelligence.main.tsx",
      "parent": "/analytics/call-intelligence"
    },
    "/analytics/practice/$feature": {
      "filePath": "analytics/practice.$feature.tsx",
      "parent": "/analytics/practice"
    },
    "/analytics/practice/main": {
      "filePath": "analytics/practice.main.tsx",
      "parent": "/analytics/practice"
    },
    "/analytics/roi/appointment-reminders": {
      "filePath": "analytics/roi.appointment-reminders.tsx",
      "parent": "/analytics/roi"
    },
    "/analytics/roi/bulk-text": {
      "filePath": "analytics/roi.bulk-text.tsx",
      "parent": "/analytics/roi"
    },
    "/analytics/roi/missed-call-text-conversion": {
      "filePath": "analytics/roi.missed-call-text-conversion.tsx",
      "parent": "/analytics/roi"
    },
    "/analytics/roi/no-show-rate": {
      "filePath": "analytics/roi.no-show-rate.tsx",
      "parent": "/analytics/roi"
    },
    "/bulk_/$subNav_/$type": {
      "filePath": "bulk_/$subNav_.$type.tsx"
    },
    "/fax/$filter/$faxId": {
      "filePath": "fax/$filter.$faxId.tsx",
      "parent": "/fax/$filter"
    },
    "/fax/drafts/$draftId": {
      "filePath": "fax/drafts/$draftId.tsx",
      "children": [
        "/fax/drafts/$draftId/begin",
        "/fax/drafts/$draftId/choose-template",
        "/fax/drafts/$draftId/cover",
        "/fax/drafts/$draftId/finalize",
        "/fax/drafts/$draftId/upload"
      ]
    },
    "/fax/drafts/new": {
      "filePath": "fax/drafts/new.tsx"
    },
    "/fax/drafts/new-from-template": {
      "filePath": "fax/drafts/new-from-template.tsx"
    },
    "/fax/drafts/template-editor": {
      "filePath": "fax/drafts/template-editor.tsx"
    },
    "/messages/$filter/new": {
      "filePath": "messages/$filter.new.tsx",
      "parent": "/messages/$filter"
    },
    "/payments/invoices_/$id": {
      "filePath": "payments/invoices_.$id.tsx"
    },
    "/payments/payment-plans_/$planId": {
      "filePath": "payments/payment-plans_.$planId.tsx"
    },
    "/payments/payment-plans_/create": {
      "filePath": "payments/payment-plans_.create.tsx"
    },
    "/payments/payouts_/$payoutId": {
      "filePath": "payments/payouts_.$payoutId.tsx"
    },
    "/payments/refunds_/$invoiceId": {
      "filePath": "payments/refunds_.$invoiceId.tsx"
    },
    "/reviews/$site/$reviewId": {
      "filePath": "reviews/$site.$reviewId.tsx",
      "parent": "/reviews/$site"
    },
    "/x_/parent/child": {
      "filePath": "x_/parent.child.tsx",
      "parent": "/x_/parent"
    },
    "/x_/redirect_/1": {
      "filePath": "x_/redirect_.1.tsx"
    },
    "/x_/redirect_/2": {
      "filePath": "x_/redirect_.2.tsx"
    },
    "/_public/test_/redirect_/1": {
      "filePath": "_public/test_/redirect_.1.tsx"
    },
    "/_public/test_/redirect_/2": {
      "filePath": "_public/test_/redirect_.2.tsx"
    },
    "/analytics/call-intelligence/follow-ups_/$type": {
      "filePath": "analytics/call-intelligence.follow-ups_.$type.tsx",
      "parent": "/analytics/call-intelligence"
    },
    "/bulk_/$subNav_/$type_/$id": {
      "filePath": "bulk_/$subNav_.$type_.$id.tsx"
    },
    "/fax/drafts/$draftId/begin": {
      "filePath": "fax/drafts/$draftId.begin.tsx",
      "parent": "/fax/drafts/$draftId"
    },
    "/fax/drafts/$draftId/choose-template": {
      "filePath": "fax/drafts/$draftId.choose-template.tsx",
      "parent": "/fax/drafts/$draftId"
    },
    "/fax/drafts/$draftId/cover": {
      "filePath": "fax/drafts/$draftId.cover.tsx",
      "parent": "/fax/drafts/$draftId"
    },
    "/fax/drafts/$draftId/finalize": {
      "filePath": "fax/drafts/$draftId.finalize.tsx",
      "parent": "/fax/drafts/$draftId"
    },
    "/fax/drafts/$draftId/upload": {
      "filePath": "fax/drafts/$draftId.upload.tsx",
      "parent": "/fax/drafts/$draftId"
    },
    "/messages/$filter/$groupId_/$threadId": {
      "filePath": "messages/$filter.$groupId_.$threadId.tsx",
      "parent": "/messages/$filter"
    },
    "/_public/accept-invite_/$nonceToken_/location_/$locationId": {
      "filePath": "_public/accept-invite_/$nonceToken_.location_.$locationId.tsx"
    },
    "/_public/user-invite_/$nonceToken_/location_/$locationId": {
      "filePath": "_public/user-invite_/$nonceToken_.location_.$locationId.tsx"
    },
    "/bulk_/$subNav_/$type_/$id_/$view": {
      "filePath": "bulk_/$subNav_.$type_.$id_.$view.tsx"
    },
    "/calls/voicemail-boxes/$mailboxId/messages/$messageId": {
      "filePath": "calls/voicemail-boxes.$mailboxId.messages.$messageId.tsx"
    }
  }
}
ROUTE_MANIFEST_END */
